<template>
  <a-modal :title="viewTitle" visible @cancel="cancel">
    <ak-inputs :options="options" ref="inputs" v-model="record" />
    <template slot="footer">
      <a-button :loading="loading" type="primary" @click="ok">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'viewPage',
  data () {
    return {
      loading: false,
      options: [
        {
          name: 'name',
          note: '活动名称',
          type: 'String',
          validators: [(val) => (val ? null : '不可为空')]
        },
        // {
        //   name: 'type',
        //   note: '发放类型',
        //   type: 'Select',
        //   items: {
        //     property: '缴纳物业费',
        //     heating: '缴纳取暖费',
        //     login: '登录'
        //   }
        // },
        // {
        //   name: 'isEnable',
        //   note: '是否启用',
        //   type: 'Boolean'
        // },
        // {
        //   name: 'residentialQuarters',
        //   note: '参与小区',
        //   type: 'Array',
        //   items: {
        //     type: 'Pointer',
        //     targetClass: 'residentialQuarters',
        //     searchKey: ['name']
        //   }
        // },
        {
          name: 'details',
          note: '代金券详情',
          type: 'Array',
          items: {
            type: 'Object',
            items: [
              {
                name: 'name',
                note: '代金券名称',
                type: 'String'
              },
              {
                name: 'shopType',
                note: '代金券类型',
                type: 'Select',
                items: {
                  unconditional: '无条件',
                  reduction: '满减'
                }
              },
              {
                name: 'total',
                note: '发放数量',
                type: 'Number'
              },
              {
                name: 'shopAmount',
                note: '使用金额',
                tooltip: '无条件类型，金额为0,，满减需要设置金额',
                type: 'Number'
              },
              {
                name: 'shopQuota',
                note: '抵扣金额',
                type: 'Number'
              }
            ]
          }
        },
        {
          name: 'day',
          note: '代金券有效天数',
          type: 'Number'
        },
        {
          name: 'user',
          note: '发放用户',
          type: 'Array',
          items: {
            type: 'Pointer',
            targetClass: '_User',
            searchKey: ['nickName', 'phone'],
            listWhere: (where) => {
              where.isAdmin = {
                $ne: true
              }
              if (!where.phone) {
                where.phone = {
                  $exists: true
                }
              }
            }
          }
        }
      ],
      record: {}
    }
  },
  mounted () {},
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    async ok () {
      this.loading = true
      // 验证数据格式
      if (
        !this.record.name ||
        !this.record.day ||
        !this.record.details ||
        this.record.details.length === 0
      ) {
        this.loading = false
        return this.$notification['error']({
          message: '数据错误',
          description: '请填写所有信息'
        })
      }
      if (!/^[1-9]\d*$/.test(this.record.day)) {
        this.loading = false
        return this.$notification['error']({
          message: '数据错误',
          description: '请正确填写代金券有效天数'
        })
      }
      // 验证表单
      for (let i in this.record.details) {
        let item = this.record.details[i]
        if (!item.name || !item.shopType) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请填写所有信息'
          })
        }
        if (!item.shopQuota || item.shopQuota <= 0) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请正确填写抵扣金额'
          })
        }
        if (!/^[1-9]\d*$/.test(item.total)) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请正确填写发放数量'
          })
        }
        if (item.shopAmount == null || item.shopAmount < 0) {
          this.loading = false
          return this.$notification['error']({
            message: '数据错误',
            description: '请正确填写使用金额'
          })
        }
      }
      // 循环创建购物代金券并保存id
      let couponId = []
      for (let i in this.record.details) {
        // 创建代金券
        let { data } = await this.$tkParse.post('/classes/coupon', {
          name: this.record.details[i].name,
          shopType: this.record.details[i].shopType,
          shopAmount:
            this.record.details[i].shopType === 'reduction'
              ? this.record.details[i].shopAmount
              : 0,
          shopQuota: this.record.details[i].shopQuota,
          total: this.record.details[i].total,
          surplus: this.record.details[i].total,
          couponType: 'shopping',
          isDel: false
        })
        couponId.push(data.objectId)
      }
      // 创建代金券活动
      let { data: couponActivity } = await this.$tkParse.post(
        '/classes/couponActivity',
        {
          name: this.record.name,
          type: 'manual',
          day: this.record.day,
          details: couponId,
          isEnable: false
        }
      )
      let couponActivityId = couponActivity.objectId
      let obj = {
        couponActivityId: couponActivityId,
        user: this.record.user,
        day: this.record.day,
        couponId: couponId
      }
      let { data: couponManual } = await this.$tkParse.post(
        '/couponManual',
        obj
      )
      this.loading = false
      this.cancel()
      this.vm.refresh()
      if (couponManual.code === '01') {
        return this.$notification['error']({
          message: '网络错误',
          description: '代金券未成功发放'
        })
      }
      this.$notification['success']({
        message: '操作成功',
        description: '代金券已成功发放'
      })
      // console.log(couponManual)
      // 发放优惠券
    }
  },
  props: {
    // record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    vm: Object, // 当前页面的vm对象
    viewTitle: {
      type: String,
      default: '新建代金券活动'
    }
  }
}
</script>

<style scoped>
</style>
